import ReportFuelVolumeTable from "./components/ReportFuelVolumeTable";

const ReportFuelVolume = () => {
  return (
    <>
      <ReportFuelVolumeTable />
    </>
  );
};

export default ReportFuelVolume;
